module.exports = __webpack_public_path__ + "media/home3-left.b8b96ed5.mp4";